var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50195 11.252C13.7516 11.2521 15.002 15.002 15.002 16.252C15.0016 17.4888 13.7769 17.5018 13.752 17.502H1.25195C1.25195 17.502 0.00226516 17.5015 0.00195312 16.252C0.00195312 15.002 1.25195 11.252 7.50195 11.252ZM16.877 6.13965C18.6108 4.35818 22.9447 7.47697 16.877 11.4863C10.8089 7.47676 15.1432 4.35762 16.877 6.13965ZM7.50195 2.50195C9.57284 2.50216 11.252 4.18101 11.252 6.25195C11.2517 8.32268 9.57269 10.0017 7.50195 10.002C5.43104 10.002 3.75221 8.32281 3.75195 6.25195C3.75195 4.18089 5.43089 2.50195 7.50195 2.50195Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconChildren);
export default __webpack_public_path__ + "static/media/nav-icon-children.ffe6ecefc1b1e43dd8018fc04a3933cc.svg";
export { ForwardRef as ReactComponent };